module.exports = __webpack_public_path__ + "img/psm_logo-inverse.86ce4657.png";